import React, { useState, useCallback, useImperativeHandle, forwardRef } from 'react';
import Toast from './Toast';

// Создаем контекст для глобального доступа к toast
export const ToastContext = React.createContext();

const ToastManager = forwardRef((props, ref) => {
  const [toasts, setToasts] = useState([]);

  // Функция для добавления уведомления
  const addToast = useCallback((message, type = 'info', duration = 5000) => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      message,
      type,
      duration
    };
    
    setToasts(prev => [...prev, newToast]);
    
    // Возвращаем ID для возможности ручного закрытия
    return id;
  }, []);

  // Функция для удаления уведомления
  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  // Функции для разных типов уведомлений
  const toastFunctions = {
    success: (message, duration) => addToast(message, 'success', duration),
    error: (message, duration) => addToast(message, 'error', duration),
    warning: (message, duration) => addToast(message, 'warning', duration),
    info: (message, duration) => addToast(message, 'info', duration)
  };

  // Делаем функции доступными через ref
  useImperativeHandle(ref, () => ({
    ...toastFunctions,
    addToast
  }));

  return (
    <ToastContext.Provider value={toastFunctions}>
      {/* Контейнер для уведомлений */}
      <div className="fixed top-4 right-4 z-50 space-y-2 pointer-events-none">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            id={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={removeToast}
          />
        ))}
      </div>
      {props.children}
    </ToastContext.Provider>
  );
});

ToastManager.displayName = 'ToastManager';

export default ToastManager;